import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import CustomCard from "../CustomCard/CustomCard";
import FormRenderer, { FormField } from "../FormRenderer";
import { GroupedFormSectionsProps } from "./GroupedFormSections.types";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormRenderGroupTypes } from "../FormRenderer/FormRenderGroup.types";


const GroupedFormSections = <T,>({
    groupedFields,
    formData,
    onChange,
    groupOrder,
    accordionMode,
    groupIcons,
    fieldErrors,
    customFilterOptions,
    autocompleteInputChangeHandlers,
    autocompleteResetKeys,
    participantsActions
}: GroupedFormSectionsProps<T>) => {
    const orderedGroups = groupOrder
        ? groupOrder.map(groupName => [groupName, groupedFields[groupName]] as [string, FormField<T>[]])
        : Object.entries(groupedFields);

    return (
      <>
        {orderedGroups.map(
          ([groupName, fields]) =>
            fields &&
            (accordionMode ? (
              <CustomCard key={groupName} sx={{ mb: 4 }}>
                <Accordion
                  defaultExpanded
                  elevation={0}
                  sx={{ boxShadow: 'none', background: 'transparent' }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{ padding: 0, minHeight: 'unset' }}
                  >
                    <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
                      {groupIcons?.[groupName] && (
                        <Box component="span" sx={{ mr: 1 }}>
                          {groupIcons[groupName]}
                        </Box>
                      )}
                      {groupName}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ paddingX: 0 }}>
                    {groupName === FormRenderGroupTypes.participants && participantsActions}
                    <FormRenderer
                      fields={fields.map((field) => ({
                        ...field,
                        error: Boolean(fieldErrors?.[String(field.name)]),
                        helperText: fieldErrors?.[String(field.name)] ?? field.helperText,
                        value: formData[field.name] ?? field.value,
                      }))}
                      onChange={onChange}
                      customFilterOptions={customFilterOptions}
                      autocompleteInputChangeHandlers={autocompleteInputChangeHandlers}
                      autocompleteResetKeys={autocompleteResetKeys}
                    />
                  </AccordionDetails>
                </Accordion>
              </CustomCard>
            ) : (
              <CustomCard key={groupName} title={groupName}>
                <FormRenderer
                  fields={fields.map((field) => ({
                    ...field,
                    error: Boolean(fieldErrors?.[String(field.name)]),
                    helperText: fieldErrors?.[String(field.name)] ?? field.helperText,
                    value: formData[field.name] ?? field.value,
                  }))}
                  onChange={onChange}
                  customFilterOptions={customFilterOptions}
                  autocompleteInputChangeHandlers={autocompleteInputChangeHandlers}
                  autocompleteResetKeys={autocompleteResetKeys}
                />
              </CustomCard>
            ))
        )}
      </>
    );
};
export default GroupedFormSections;
